import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-bca.component.scss';
import { ProvincialCityService } from '../sa-provincial-city/sa-provincial-city.service';
var FormItemBusinessBca = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessBca, _super);
    function FormItemBusinessBca(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessBca.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button-business-bca"));
        this.businessType = this.element.querySelector(".js-business-type");
        this.helpDropDown = this.element.querySelector(".js-enquiry-type");
        if (this.helpDropDown) {
            this.displayEnquiryForm(this.helpDropDown.value);
        }
        this.provincialCityService = ProvincialCityService.getInstance();
    };
    FormItemBusinessBca.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.businessType) {
            this.businessType.addEventListener("change", function () {
                _this.validateBusinessType("validate");
                _this.showIdOrCoreg();
            });
        }
        if (this.helpDropDown) {
            this.helpDropDown.addEventListener("change", function () { return _this.displayEnquiryForm(_this.helpDropDown.value); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.displayEnquiryForm("Enquiry");
        }, false);
        /*
        const provinceSelect: HTMLSelectElement = this.form.querySelector(`select[name=province]`);
        provinceSelect.addEventListener(`change`, ( event ) => {
            this.populateCities(provinceSelect.value);
        });
        this.populateProvinces();
        */
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector('.form__input--busReg');
        if (businessReg) {
            businessReg.addEventListener('input', function (event) {
                if ((event.inputType !== 'deleteContentBackward') && (event.inputType !== 'deleteContentForward')) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener('blur', function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
    };
    FormItemBusinessBca.prototype.validateBusinessType = function (type) {
        this.businessOtherDropdown();
    };
    FormItemBusinessBca.prototype.businessOtherDropdown = function () {
        var field = this.businessType;
        var formGroup = field.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        var formNote = this.element.querySelector(".apply-now__note");
        var formButtons = this.element.querySelector(".apply-now__buttons");
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "OtherContent") {
            formGroups.map(function (item) {
                item.classList.add("form__group--hidden");
            });
            formNote.classList.add("hidden");
            formButtons.classList.add("hidden");
            formOtherContainer.classList.add("active");
        }
        else {
            formGroups.map(function (item) {
                item.classList.remove("form__group--hidden");
            });
            formNote.classList.remove("hidden");
            formButtons.classList.remove("hidden");
            formOtherContainer.classList.remove("active");
        }
        formGroup.classList.remove("form__group--hidden");
    };
    FormItemBusinessBca.prototype.displayEnquiryForm = function (select) {
        var provincialCityGroup = this.element.querySelectorAll(".provincial-city-group");
        switch (select) {
            case "NewAccount":
                Array.from(this.form.querySelectorAll(".js-business-acc-field")).forEach(function (element) {
                    element.classList.remove("form__group--hidden");
                });
                this.showIdOrCoreg();
                break;
            case "Enquiry":
            default:
                Array.from(this.form.querySelectorAll(".js-business-acc-field")).forEach(function (element) {
                    element.classList.add("form__group--hidden");
                });
        }
    };
    FormItemBusinessBca.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var enquiryType = form.querySelector("select[name=enquiry-type]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        if (enquiryType && (enquiryType.value === "Enquiry")) {
            if (popiaConsent) {
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // variables
                var email = form.querySelector("input[name=email]");
                var recipient = form.querySelector("input[name=recipient]");
                var subject = form.querySelector("input[name=subject]");
                var description = form.querySelector("input[name=description]");
                var firstname = form.querySelector("input[name=first-name]");
                var lastname = form.querySelector("input[name=last-name]");
                var phoneNumber = form.querySelector("input[name=phone-number]");
                var altPhoneNumber = form.querySelector("input[name=alternative-number]");
                var emailAddress = form.querySelector("input[name=email-address]");
                var sbCustomer = form.querySelector("input[name=existing-customer]");
                var _postData = {
                    'email': (email ? email.value : ""),
                    'recipient': (recipient ? recipient.value : ""),
                    'subject': (subject ? subject.value : ""),
                    'product': (description ? description.value : ""),
                    'first-name': (firstname ? firstname.value : ""),
                    'last-name': (lastname ? lastname.value : ""),
                    'phone-number': (phoneNumber ? phoneNumber.value : ""),
                    'alternative-number': (altPhoneNumber ? altPhoneNumber.value : ""),
                    'email-address': (emailAddress ? emailAddress.value : ""),
                    'banking-with-standard-bank': ((sbCustomer ? (sbCustomer.checked ? "YES" : "NO") : "")),
                    'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
                };
                var _documents = thankYou.querySelector(".form__thankyou--documents");
                if (_documents) {
                    _documents.style.display = "none";
                }
                // service
                var url_1 = this.baseUrl + "/services/BusinessEnquiryForm.jsp";
                this.formsService.postForm(url_1, this.http.serialiseObject(_postData)).then(function (pResponse) {
                    // service ok
                    loader.classList.remove("active");
                    if (pResponse.data.includes('invalid')) {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_1);
                        fieldsContainer.classList.remove("hidden");
                    }
                    else {
                        _this.analyticsService.dtmFormComplete("complete", "");
                        loader.classList.remove("active");
                        thankYou.classList.add("active");
                    }
                }).catch(function (pError) {
                    // service failed
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_1);
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                });
            }
            else {
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // variables
                var email = form.querySelector("input[name=email]");
                var recipient = form.querySelector("input[name=recipient]");
                var subject = form.querySelector("input[name=subject]");
                var description = form.querySelector("input[name=description]");
                var firstname = form.querySelector("input[name=first-name]");
                var lastname = form.querySelector("input[name=last-name]");
                var phoneNumber = form.querySelector("input[name=phone-number]");
                var altPhoneNumber = form.querySelector("input[name=alternative-number]");
                var emailAddress = form.querySelector("input[name=email-address]");
                var sbCustomer = form.querySelector("input[name=existing-customer]");
                var _postData = {
                    'email': (email ? email.value : ""),
                    'recipient': (recipient ? recipient.value : ""),
                    'subject': (subject ? subject.value : ""),
                    'description': (description ? description.value : ""),
                    'firstname': (firstname ? firstname.value : ""),
                    'surname': (lastname ? lastname.value : ""),
                    'contactNo': (phoneNumber ? phoneNumber.value : ""),
                    'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
                    'email-address': (emailAddress ? emailAddress.value : ""),
                    'banking-with-standard-bank': ((sbCustomer ? (sbCustomer.checked ? "YES" : "NO") : "")),
                    'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO"))
                };
                var _documents = thankYou.querySelector(".form__thankyou--documents");
                if (_documents) {
                    _documents.style.display = "none";
                }
                // service
                var url_2 = this.baseUrl + "/services/genericform.jsp";
                this.formsService.postForm(url_2, this.http.serialiseObject(_postData)).then(function (pResponse) {
                    // service ok
                    _this.analyticsService.dtmFormComplete("complete", "");
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                }).catch(function (pError) {
                    // service failed
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_2);
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                });
            }
        }
        else {
            // loader + hide form
            loader.classList.add("active");
            fieldsContainer.classList.add("hidden");
            // variables
            var description = form.querySelector("input[name=description]");
            var firstname = form.querySelector("input[name=first-name]");
            var lastname = form.querySelector("input[name=last-name]");
            var businessType = form.querySelector("select[name=business-type]");
            var businessName = form.querySelector("input[name=business-name]");
            var phoneNumber = form.querySelector("input[name=phone-number]");
            var altPhoneNumber = form.querySelector("input[name=alternative-number]");
            var emailAddress = form.querySelector("input[name=email-address]");
            var businessRegNumber = form.querySelector("input[name=business-reg-number]");
            var idnumber = form.querySelector("input[name=id-number]");
            var existingCustomer = form.querySelector("input[name=existing-customer]");
            var province = "Gauteng"; // form.querySelector(`select[name=province]`) as HTMLSelectElement;
            var city = ""; // form.querySelector(`select[name=city]`) as HTMLSelectElement;
            var splitIndicator = this.getSplitIndicator("", "");
            var _postData = {
                'description': (description ? description.value : ""),
                'firstname': (firstname ? firstname.value : ""),
                'surname': (lastname ? lastname.value : ""),
                'businessType': (businessType ? businessType.value : ""),
                'businessName': (businessName ? businessName.value : ""),
                'contactNo': (phoneNumber ? phoneNumber.value : ""),
                'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
                'email': (emailAddress ? emailAddress.value : ""),
                'businessRegNumber': (businessRegNumber ? businessRegNumber.value : ""),
                'idNumber': (idnumber ? idnumber.value : ""),
                'isExistingCustomer': ((existingCustomer && existingCustomer.checked) ? "YES" : "NO"),
                'source': this.formsService.isMobile(),
                'province': 'Gauteng',
                'splitFlag': splitIndicator,
                'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            };
            var serviceEndPoint = this.getServiceEndpointURL(splitIndicator);
            // service
            var url_3 = "/services/" + serviceEndPoint;
            this.formsService.postForm(url_3, this.http.serialiseObject(_postData)).then(function (pResponse) {
                // service ok
                loader.classList.remove("active");
                if (pResponse.data === "invalid") {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_3);
                    fieldsContainer.classList.remove("hidden");
                }
                else {
                    _this.analyticsService.dtmFormComplete("complete", pResponse.data);
                    thankYou.classList.add("active");
                    var _documents = thankYou.querySelector(".form__thankyou--documents");
                    if (_documents) {
                        _documents.removeAttribute("style");
                        var _buttonContainer = _documents.querySelector(".form__thank--documents-button");
                        var _subject = "My Reference Number Is: " + pResponse.data;
                        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company";
                        var _mailtoText = "mailto:SmallEnterpriseSales@standardbank.co.za?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
                        var _newButton = document.createElement("a");
                        _newButton.classList.add("button", "button--large", "button--centered", "button--main");
                        _newButton.setAttribute("data-id", "link_content_ documents email click");
                        _newButton.setAttribute("data-text", "email documents button click");
                        _newButton.setAttribute("href", _mailtoText);
                        var _text = document.createTextNode("EMAIL DOCUMENTS");
                        _newButton.appendChild(_text);
                        _buttonContainer.innerHTML = "";
                        _buttonContainer.appendChild(_newButton);
                    }
                }
            }).catch(function (pError) {
                // service failed
                _this.analyticsService.dtmRecordSiteError("noerrorcode | service failure occurred | " + url_3);
                loader.classList.remove("active");
                fieldsContainer.classList.remove("hidden");
            });
        }
    };
    FormItemBusinessBca.prototype.populateProvinces = function () {
        var provinceSelect = this.form.querySelector("select[name=province]");
        var provinces = this.provincialCityService.getProvices();
        provinces['provinces'].forEach(function (province) {
            var provinceOption = document.createElement("option");
            provinceOption.setAttribute("value", province["value"]);
            provinceOption.appendChild(document.createTextNode(province["name"]));
            provinceSelect.appendChild(provinceOption);
        });
    };
    FormItemBusinessBca.prototype.populateCities = function (provinceValue) {
        var citySelectWrapper = this.form.querySelector(".city-selection-wrapper");
        var cities = this.provincialCityService.getCities(provinceValue);
        // clean up
        var citiesSelect = this.form.querySelector("select[name=city]");
        while (citiesSelect.lastChild) {
            var selectOption = citiesSelect.lastChild;
            if (selectOption.value) {
                citiesSelect.removeChild(citiesSelect.lastChild);
            }
            else {
                break;
            }
        }
        if (cities) {
            // clear and rebuild cities select options
            cities['cities'].forEach(function (city) {
                var cityOption = document.createElement("option");
                cityOption.setAttribute("value", city["value"]);
                cityOption.appendChild(document.createTextNode(city["name"]));
                citiesSelect.appendChild(cityOption);
            });
            // display cities
            citySelectWrapper.classList.remove("form__group--hidden");
        }
        else {
            citySelectWrapper.classList.add("form__group--hidden");
        }
    };
    FormItemBusinessBca.prototype.getSplitIndicator = function (province, city) {
        switch (province) {
            case "Gauteng":
            case "KwaZulu-Natal":
                return "CST";
            default:
                return "DFC";
        }
    };
    FormItemBusinessBca.prototype.getServiceEndpointURL = function (splitIndicator) {
        switch (splitIndicator) {
            case "CST":
                return "CozaBusinessForm.jsp";
            default:
                return "SubmitApplicationFormBizBankV1.jsp";
        }
    };
    FormItemBusinessBca.prototype.showCitySelection = function () {
        var citySelectWrapper = this.form.querySelector(".city-selection-wrapper");
        var entityType = this.businessType.value;
        if (entityType !== "OtherContent") {
            var province = this.form.querySelector("select[name=province]");
            var city = this.form.querySelector("select[name=city]");
            this.populateCities(province.value);
        }
        else {
            citySelectWrapper.classList.add("form__group--hidden");
        }
    };
    FormItemBusinessBca.prototype.showIdOrCoreg = function () {
        var entityType = this.businessType.value;
        var idNumberWrapper = this.form.querySelector(".js-input_id-number-wrapper");
        var coregWrapper = this.form.querySelector(".js-input__busReg");
        switch (entityType) {
            case "Private Company":
            case "Close Corporation":
                coregWrapper.classList.remove("form__group--hidden");
                idNumberWrapper.classList.add("form__group--hidden");
                break;
            case "OtherContent":
                break;
            default:
                idNumberWrapper.classList.remove("form__group--hidden");
                coregWrapper.classList.add("form__group--hidden");
        }
    };
    return FormItemBusinessBca;
}(Base));
export { FormItemBusinessBca };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-bca/form-item-business-bca.component.ts
// module id = 841
// module chunks = 0